export interface IColumn {
  label: string;
  isReadOnly?: boolean;
  isNotPut?: boolean;
  isSearchable?: boolean;
  isArray?: boolean;
  isCheckbox?: boolean;
  rel?: string;
  placeholder?: string;
  nameDropDown?: string;
  name?: string;
}

export function column(arg: IColumn) {
  return (target: AbstractDataClass<any>, prop: string) => {
    arg.rel = prop;
    arg.isReadOnly = arg.isReadOnly && true;
    arg.isNotPut = arg.isNotPut && true;
    arg.isSearchable = arg.isSearchable && true;
    arg.isArray = arg.isArray && true;
    if (target.columns === undefined) target.columns = [];
    target.columns.push(arg);
  };
}

export abstract class AbstractDataClass<T> {
  public columns: Array<IColumn>;
  [key: string]: any;
}
